/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：332
 */

module.exports = {
  soundLibraryItem: "style_soundLibraryItem__2IxX7",
  selected: "style_selected__3j5zE",
  icon: "style_icon__2gigA",
  content: "style_content__1THnT",
  soundBox: "style_soundBox__1XcTF",
  soundIconBox: "style_soundIconBox__1jmTR",
  soundDefaultIcon: "style_soundDefaultIcon__1c_8q",
  soundPlayIconBox: "style_soundPlayIconBox__3oJfk",
  soundPauseIconBox: "style_soundPauseIconBox___hY4g",
  progressWrapper: "style_progressWrapper__bJtYd",
  rightWrapper: "style_rightWrapper__3_uEs",
  leftWrapper: "style_leftWrapper__mc9K5",
  circleProgress: "style_circleProgress__1CPzz",
  rightCircle: "style_rightCircle__2J98S",
  circleProgressLoad_right: "style_circleProgressLoad_right__1GkzV",
  leftCircle: "style_leftCircle__21SB6",
  circleProgressLoad_left: "style_circleProgressLoad_left__n641N",
  footer: "style_footer__26GaD",
  soundDuration: "style_soundDuration__2YqcR"
}
